<div [id]="id" style="width:600px; height:800px;">
    <canvas #mount></canvas>
</div>